import CanvasWrapper from './CanvasWrapper';

export default CanvasWrapper;
